// extracted by mini-css-extract-plugin
var _1 = "PageInfo__loading--YGgXX";
var _2 = "PageInfo__main--LxT8K";
export { _1 as "loading", _2 as "main" }
